<form [formGroup]="form">
  <hr *ngIf="showSeparator" />
  <ng-template
    [ngTemplateOutlet]="titleTemplate || defaultTitleTemplate"
    [ngTemplateOutletContext]="{ title: title, groupAdded: addNewGroup }"
  ></ng-template>
  <ng-template [ngIf]="isTemplate(validatorsMessageTemplate)" [ngIfElse]="noValidatorsTemplate">
    <ng-template [ngTemplateOutlet]="validatorsMessageTemplate" [ngTemplateOutletContext]="{ items: items }"></ng-template>
  </ng-template>
  <div formArrayName="items">
    <ng-template [ngIf]="items.controls.length > 0" [ngIfElse]="init">
      <div class="row" *ngFor="let group of items.controls; let groupIndex = index">
        <ng-template
          [ngTemplateOutlet]="contentTemplateRef"
          [ngTemplateOutletContext]="{ groupIndex: groupIndex, group: group, groupRemoved: removeGroup }"
        ></ng-template>
      </div>
    </ng-template>
  </div>
  <ng-template #noValidatorsTemplate>
    <div class="row" *ngIf="validatorsMessageTemplate">
      <div class="mb-3 text-secondary col-12">
        <small class="form-text">{{ validatorsMessageTemplate }}</small>
      </div>
    </div>
  </ng-template>
  <ng-template #init>
    <div class="col-12 mb-2">
      <p>
        <span>{{ noGroupText }}</span>
      </p>
    </div>
  </ng-template>
  <ng-template #defaultTitleTemplate>
    <div class="row">
      <div class="col-12">
        <div class="d-flex justify-content-between">
          <h5 class="text-primary">{{ title }}</h5>
          <button type="button" class="btn btn-primary" ngbTooltip="Ajouter" placement="left" (click)="addNewGroup()" [disabled]="disabled">
            <fa-icon icon="plus"></fa-icon>
          </button>
        </div>
      </div>
    </div>
  </ng-template>
</form>
